import { useMemo } from 'react'

import * as OrderTexts from '../../../../../../../intl'
import { form } from '../../../../formState'
import { Props } from '../../typings'

import isTagsColliding from './validation/isTagsColliding'

export function Tags(props: Props) {
  const { orderStepType, tags, maxTagsCount } = props

  const tagsInFieldName = `${orderStepType}.tagsIn` as 'pickup.tagsIn' | 'delivery.tagsIn'
  const tagsOutFieldName = `${orderStepType}.tagsOut` as 'pickup.tagsOut' | 'delivery.tagsOut'

  const tagsInValue = form.useFormField(tagsInFieldName).field.value
  const tagsOutValue = form.useFormField(tagsOutFieldName).field.value

  // Options for TagsIn
  const tagsInOptions = useMemo(
    () =>
      tags.map(tag => ({
        label: tag,
        value: tag,
        disabled: tagsOutValue?.includes(tag), // Disable if the tag is already in tagsOut
      })),
    [tags, tagsOutValue],
  )

  // Options for TagsOut
  const tagsOutOptions = useMemo(
    () =>
      tags.map(tag => ({
        label: tag,
        value: tag,
        disabled: tagsInValue?.includes(tag), // Disable if the tag is already in tagsIn
      })),
    [tags, tagsInValue],
  )

  //Tags in validation
  form.useAddFieldValidation<typeof tagsInFieldName>(tagsInFieldName, field => {
    if (!field.value) return

    if (isTagsColliding(field.value, tagsOutValue)) {
      return OrderTexts.getValidationErrorTagsCollisionText()
    }

    if (maxTagsCount && field.value.length > maxTagsCount) {
      return OrderTexts.getValidationErrorTagsMaxCountReachedText(maxTagsCount)
    }
  })

  //Tags out validation
  form.useAddFieldValidation<typeof tagsOutFieldName>(tagsOutFieldName, field => {
    if (!field.value) return

    if (isTagsColliding(tagsInValue, field.value)) {
      return OrderTexts.getValidationErrorTagsCollisionText()
    }

    if (maxTagsCount && field.value.length > maxTagsCount) {
      return OrderTexts.getValidationErrorTagsMaxCountReachedText(maxTagsCount)
    }
  })

  return (
    <form.Fieldset>
      <form.TagsField
        label={OrderTexts.getTagsInLabelText()}
        name={`${orderStepType}.tagsIn`}
        options={tagsInOptions}
        testId="tagsIn"
      />

      <form.TagsField
        label={OrderTexts.getTagsOutLabelText()}
        name={`${orderStepType}.tagsOut`}
        options={tagsOutOptions}
        testId="tagsOut"
      />
    </form.Fieldset>
  )
}
